<template>
    <div class="nav-bg"></div>
    <div class="nav">
        <div class="nav-box0"><p class="rl0">Create magic with technology</p></div>
        <div class="nav-box"><router-link class="rllogo" to="/"><img class="logo" src="../assets/mylogo.png"></router-link></div>
        <ul>
            <li>
                <div class="rl" >HOME</div>
                <div>
                    <router-link class="rl" to="/">产品设计 ProductDesign</router-link>
                    <router-link class="rl" to="/">品牌设计 BrandDesign</router-link>
                    <router-link class="rl" to="/">概念设计 ConceptDesign</router-link>
                    <router-link class="rl" to="/">联名出品 CooperatedProduce</router-link>
                </div>
            </li>
            <li>
                <div class="rl">PROJECT</div>
                <div>
                    <router-link class="rl" :to="{path:'/3dmap', query: { id: '空间导览' }}">空间导览</router-link>
                    <router-link class="rl" :to="{path:'/projectdetails', query: { id: '太空概念' }}">太空概念</router-link>
                    <router-link class="rl" :to="{path:'/projectdetails', query: { id: '交互&视觉' }}">交互&视觉</router-link>
                    <router-link class="rl" :to="{path:'/projectdetails', query: { id: '创作者激励计划' }}">创作者激励计划</router-link>
                </div>
            </li>
            <li>
                <div class="rl">ABOUT</div>
                <div>
                    <router-link class="rl" to="/about">品牌理念 Brand Philosophy</router-link>
                    <router-link class="rl" to="/">发展历程 Development</router-link>
                    <router-link class="rl" to="/">团队介绍 TeamIntroduction</router-link>
                    <router-link class="rl" to="/">加入我们 JoinUs</router-link>
                </div>
            </li>
        </ul>
    </div>
</template>

<style  scoped>

ul{
    list-style: none;
    display: flex;
    justify-content: space-evenly;
    width: 33.333%;
}
ul li{
    position: relative; 
}
ul li .rl{
    color: #FFE9A2;
    cursor: pointer;
}
ul li div+div{
    background-color: #00181b85;
    display: flex;
    flex-direction: column;
    position: absolute;
    transform-origin: left top;
    transform: scale(0);
    z-index: 100;
    transition: .6s;
    width: 100%;
    
}
ul li div+div .rl{
    display: inline-block;
    color: #FFE9A2;
    text-align: start;
    text-decoration: none;
    padding-top: 1em;
    padding-left: 0.5em;
    padding-bottom: 1em;
    width: 100%;
    font-size: 0.8em;
}

ul li div+div .rl:hover{
    background-color: #013c4485;
    color: #FFE9A2;
}
ul li:hover div+div{
    transform: scale(1);
}
.rllogo{
    display: flex;
    align-self: center;
    justify-self: center;
    width: auto;
    height: 40%;

}
.logo{
    height: 100%;
}
.nav-bg{
    z-index: 100;
    overflow: hidden;
    margin: 0;
    padding: 0;
    position: fixed;
    width:100%;
    height: 8vh;
    background-color: #00181b85;
}
.nav {
user-select: none;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width:100%;
  height: 8vh;

}
.nav-box{
    width: 33.333%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.nav-box0{
    width: 33.333%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.nav-box1{
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}

.rl{
    font-size: 1vw;
    color: #FFE9A2;
    text-decoration: none;
    margin-right: 5vw;
}
.rl0{
    font-size: 1vw;
    color: #FFE9A2;
    text-decoration: none;
    margin-left: 5vw;
}
@media screen and (max-width:900px) {
    .logo{
        height: 30%;
    }
    .nav-box{
        width: 40%;
    }
    .nav-bg{
        height: 10vh;
    }
    .nav{
        height: 10vh;
    }
    .nav-box0{
        display: none;
    }
    .nav-box1{
        display: none;
    }
    
}
</style>